import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { bem } from 'helpers/class-name';
import { Card } from 'components/Card';
import Roster from 'components/Roster';
import EmptyList from '../../EmptyList';
import messages from '../../ManageServices.messages';
import PractitionersListItem from '../PractitionersListItem';

const { block } = bem('practitioners-list');

const PractitionersList = ({ practitioners, isLoading }) => {
  const blockClasses = block('mb-0');

  if (isLoading || _isEmpty(practitioners)) {
    return (
      <Card className={blockClasses} loading={isLoading} centered>
        <EmptyList
          header={messages.empty.practitionersHeader}
          text={messages.empty.practitionersText}
          button={messages.addBtn.practitioner}
        />
      </Card>
    );
  }

  return (
    <Roster
      data={practitioners}
      RowComponent={PractitionersListItem}
      getKey={({ id }) => id}
      className={blockClasses}
      sortableField="firstName"
    />
  );
};

PractitionersList.propTypes = {
  practitioners: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      avatarUrl: PropTypes.string,
    })
  ),
  isLoading: PropTypes.bool,
};

export default PractitionersList;
